// extracted by mini-css-extract-plugin
export default {"hualiumeta_body":"hualiumeta_hualiumeta_body__pll81","content":"hualiumeta_content__8kfvQ"};